// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"50384988","75":"3f0336b0","296":"191b0e6a","829":"ef041933","946":"9395c076"}[chunkId] + ".chunk.js";
};